import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpService } from 'app/services/http.service';
import { Message, MessageService } from 'primeng/api';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-prefactura',
  templateUrl: './prefactura.component.html',
  styleUrls: ['./prefactura.component.scss']
})

export class PrefacturaComponent implements OnInit {

  empresas: any[] = []
  empresasFiltered: any[] = []
  facturas: any;
  forma: FormGroup;
  folioAPagar: number;
  estaEditando: boolean = false;
  esPrimeraVez: boolean = true;
  pagando: boolean = true;
  usuario: any;
  msgs: Message[] = []

  valorMensual: number = 10000
  totalRecaudacionMes: number = 0
  totalInstalaciones: number = 0
  meses: any[];
  years: any[] = [];
  mesSelected: any;
  yearSelected: any;

  completos: number
  recienCreados: number = 0
  menosDeTresDias: number = 0
  eliminadosMesAnterior: number;

  constructor(private http: HttpService,
    private formBuilder: FormBuilder,
    private router: Router,
    public messageService: MessageService,
    private ngZone: NgZone
  ) {

    this.usuario = JSON.parse(this.http.getLocalstorage('usuario'))

    this.getFacturas()
  }

  ngOnInit(): void {

    this.meses = [
      { m: 0, mes: 'ENERO' },
      { m: 1, mes: 'FEBRERO' },
      { m: 2, mes: 'MARZO' },
      { m: 3, mes: 'ABRIL' },
      { m: 4, mes: 'MAYO' },
      { m: 5, mes: 'JUNIO' },
      { m: 6, mes: 'JULIO' },
      { m: 7, mes: 'AGOSTO' },
      { m: 8, mes: 'SEPTIEMBRE' },
      { m: 9, mes: 'OCTUBRE' },
      { m: 10, mes: 'NOVIEMBRE' },
      { m: 11, mes: 'DICIEMBRE' },
    ]

    const thisYear = new Date().getFullYear()

    for (let i = thisYear; i >= 2023; i--) {
      this.years.push({ year: i });
    }

    const m = new Date().getMonth()
    this.mesSelected = this.meses.find(e => e.m == m)
    this.yearSelected = this.years.find(e => e.year == thisYear)

    this.forma = this.formBuilder.group({
      DescripcionSvc: new FormControl('', [Validators.required]),
      Monto: new FormControl('', [Validators.required, Validators.minLength(3)]),
    })
  }

  detalle: any[]
  montoAPagar: number;

  total: number = 0
  carroCompra: any[] = [];

  async getFacturas() {
    this.empresas = await this.http.getinstalacionesGroupByEmpresaService()

    //this.empresas = this.empresas.filter(e => e.NombreEmpresa == 'SERVICIOS DE SEGURIDAD PRIVADA FALCON SPA')


    console.log('empresas', this.empresas);

    const esteMes = new Date().getMonth()
    this.empresas.forEach(element => {
      if (!element.Eliminado)
        return

      const mesEliminacion = new Date(element.FechaEliminacion).getMonth()

      if (esteMes - mesEliminacion > 2) {

      }
    });

    await this.evalua()
  }


  async evalua(): Promise<void> {
    this.totalInstalaciones = 0
    this.totalRecaudacionMes = 0

    const esteMes = new Date(this.yearSelected.year, this.mesSelected.m)

    this.empresasFiltered = JSON.parse(JSON.stringify(this.empresas.filter(e => new Date(e.createdAt) < esteMes)))

    console.log('this.empresasFiltered.length', this.empresasFiltered.length);


    this.empresasFiltered.forEach(empresa => {

      //console.log('NombreEmpresa', empresa.NombreEmpresa);

      // if (empresa.NombreEmpresa == 'SERVICIOS DE SEGURIDAD PRIVADA FALCON SPA') {
      //   empresa.NombreEmpresa = 'SERVICIOS DE SEGURIDAD PRIVADA FALCON SPA'
      // }

      const aux = empresa.Instalaciones
      //const instalaciones = aux.filter(e => new Date(e.createdAt).getMonth() <= esteMes.getMonth())
      const instalaciones = aux

      this.completos = 0
      this.recienCreados = 0
      this.menosDeTresDias = 0
      this.eliminadosMesAnterior = 0

      let totalEmpresa = 0
      instalaciones.forEach(inst => {
        let creado = new Date(inst.createdAt)

        //console.log(inst.Nombre);

        const mes = new Date(creado.getFullYear(), creado.getMonth())

        if (!inst.Eliminado) {


          if (inst.Nombre == 'EDIFICIO GOBIERNO REGIONAL')
            inst.Nombre = 'EDIFICIO GOBIERNO REGIONAL'

          // Instalaciones que están desde el mes anterior
          if (this.getMonthDifference(mes, esteMes) > 1) {
            totalEmpresa += this.valorMensual

            // Muestra el monto de esta inst. en el HTML
            inst.Monto = this.valorMensual

            this.completos++
          }

          // Instalaciones agregadas este mes
          else if (this.getMonthDifference(mes, esteMes) <= 1) {
            const lastDay = this.getLastDayOfMonth(mes.getMonth())
            const day = new Date(inst.createdAt).getDate()

            if (lastDay - day <= 3) {
              this.menosDeTresDias++
              inst.Monto = 0
            }
            else {
              const aux = Math.round((this.valorMensual / lastDay) * (lastDay - day + 1))

              // Muestra el monto de esta inst. recién creada en el HTML
              inst.Monto = aux

              totalEmpresa += aux
              this.recienCreados++
            }
          }
        }

        // Instalaciones eliminadas
        else {
          //console.log('eliminada', inst);

          const tiempoDeVida = new Date(inst.updatedAt).getTime() - new Date(inst.createdAt).getTime()
          const cuatroDias = 4 * 24 * 60 * 60 * 1000
          if (tiempoDeVida < cuatroDias) {
            inst.Monto = 0
            return;
          }

          let aux = new Date(inst.FechaEliminacion)

          const mesEliminacion = new Date(aux.getFullYear(), aux.getMonth())

          if (this.getMonthDifference(mesEliminacion, esteMes) == 1) {
            const diaEliminacion = new Date(inst.FechaEliminacion).getDate()
            const lastDay = this.getLastDayOfMonth(new Date(inst.FechaEliminacion).getMonth())
            const aux = Math.round((this.valorMensual / lastDay) * (diaEliminacion))

            // Muestra el monto de esta inst. eliminada en el HTML
            inst.Monto = aux

            totalEmpresa += aux
            this.eliminadosMesAnterior++
          }
          else {
            // Muestra el monto de esta inst. eliminada en el HTML
            inst.Monto = 0
          }
        }

      });
      //console.log('---------');
      this.totalInstalaciones += this.completos + this.recienCreados + this.menosDeTresDias

      // console.log('this.totalInstalaciones', this.totalInstalaciones);
      // console.log('----------');

      empresa.Total = totalEmpresa
      empresa.Completos = this.completos
      empresa.RecienCreados = this.recienCreados
      empresa.MenosDeTresDias = this.menosDeTresDias
      empresa.EliminadosMesAnterior = this.eliminadosMesAnterior

      //this.totalRecaudacionMes += totalEmpresa
    });

    console.log('this.empresasFiltered', this.empresasFiltered);

    this.ngZone.run(() => { })


    // this.empresasFiltered.forEach(empresa => {

    //   empresa.Instalaciones.forEach(inst => {
    //     if (!inst.Monto) {
    //       if (inst.Monto !=0) {
    //         console.log('sin monto');
    //         console.log('Monto:', inst.Monto);
    //       }
    //     }
    //   });
    // });

    await this.getSupervisores()

  }

  async getSupervisores(): Promise<void> {
    let _sup = await this.http.getAllSupervisoresService();
    console.log('supervisores', _sup);

    const esteMes = new Date(this.yearSelected.year, this.mesSelected.m)
    const supervisores = _sup.filter(e => new Date(e.createdAt) < esteMes)

    let totalSupervisores = 0

//    this.empresasFiltered = JSON.parse(JSON.stringify(this.empresas.filter(e => new Date(e.createdAt) < esteMes)))

    supervisores.forEach(supervisor => {
      const empresa = this.empresasFiltered.find(e => e._id == supervisor.Empresa._id)

      // if (empresa.NombreEmpresa == 'SERVICIOS DE SEGURIDAD PRIVADA FALCON SPA')
      //   empresa.NombreEmpresa = 'SERVICIOS DE SEGURIDAD PRIVADA FALCON SPA'

      if (!empresa)
        return false;

      let aux = new Date(supervisor.createdAt)

      console.log('aux', aux);
      

      const mes = new Date(aux.getFullYear(), aux.getMonth())
      //Modifica el nombre para identificarlo
      supervisor.Nombre = '(SUPERVISOR) ' + supervisor.Nombre

console.log('esteMes', esteMes);


      if (!supervisor.Eliminado) {
        // Supervisores que están desde el mes anterior
        if (this.getMonthDifference(mes, esteMes) >= 2) {
          totalSupervisores += this.valorMensual

          // Muestra el monto de este supervisor en el HTML
          supervisor.Monto = this.valorMensual

          this.completos++
        }

        // Supervisores agregados este mes
        else if (this.getMonthDifference(mes, esteMes) <= 1) {
          const lastDay = this.getLastDayOfMonth(mes.getMonth())
          const day = new Date(supervisor.createdAt).getDate()

          if (lastDay - day <= 3) {
            this.menosDeTresDias++
            supervisor.Monto = 0
          }
          else {
            const aux = Math.round((this.valorMensual / lastDay) * (lastDay - day + 1))

            // Muestra el monto de esta inst. recién creada en el HTML
            supervisor.Monto = aux

            totalSupervisores += aux
            this.recienCreados++
          }
        }
      }

      // Supervisores eliminados
      else {
        console.log('Supervisor eliminado:', supervisor);

        const tiempoDeVida = new Date(supervisor.updatedAt).getTime() - new Date(supervisor.createdAt).getTime()
        const cuatroDias = 4 * 24 * 60 * 60 * 1000
        if (tiempoDeVida < cuatroDias) {
          supervisor.Monto = 0
          return;
        }

        const mesEliminacion = new Date(supervisor.FechaEliminacion)

        // Se eliminó el mes pasado y se calcula el proporcional
        if (this.getMonthDifference(mesEliminacion, esteMes) <= 1 || this.getMonthDifference(mesEliminacion, esteMes) >= 0) {
          const diaEliminacion = new Date(supervisor.FechaEliminacion).getDate()
          const lastDay = this.getLastDayOfMonth(mesEliminacion.getMonth())
          const aux = Math.round((this.valorMensual / lastDay) * (diaEliminacion))

          // Muestra el monto de este supervisor eliminado en el HTML
          supervisor.Monto = aux

          totalSupervisores += aux
          this.eliminadosMesAnterior++
        }

        // // Se eliminó este mes
        // else if(esteMes == mesEliminacion){

        // }
        else {
          // Muestra el monto de este supervisor eliminado en el HTML
          supervisor.Monto = 0
        }
      }

      empresa.Total += supervisor.Monto

      empresa.Instalaciones.push({
        Nombre: supervisor.Nombre,
        Monto: supervisor.Monto,
        createdAt: supervisor.createdAt,
        updatedAt: supervisor.updatedAt,
      })
    });

    this.empresasFiltered.forEach(element => {
      const aux = supervisores.filter(e => e.Empresa._id == element._id)
      element.Supervisores = aux.length

      this.totalRecaudacionMes += element.Total
    });

    this.ngZone.run(() => { })
  }

  getMonthDifference(startDate, endDate) {
    return (
      endDate.getMonth() - startDate.getMonth() + 12 * (endDate.getFullYear() - startDate.getFullYear())
    );
  }

  getLastDayOfMonth(month) {
    let lastDay = 0
    switch (month) {
      case 0:
        lastDay = 31
        break;
      case 1:
        lastDay = 28
        break;
      case 2:
        lastDay = 31
        break;
      case 3:
        lastDay = 30
        break;
      case 4:
        lastDay = 31
        break;
      case 5:
        lastDay = 30
        break;
      case 6:
        lastDay = 31
        break;
      case 7:
        lastDay = 31
        break;
      case 8:
        lastDay = 30
        break;
      case 9:
        lastDay = 31
        break;
      case 10:
        lastDay = 30
        break;
      case 11:
        lastDay = 31
        break;
    }
    return lastDay
  }

}
